export class Operator {
  constructor(operator = {}) {
    this.id = operator.id;
    this.name = operator.name;
    this.createdAt = operator.createdAt;
    this.codes = (operator.codes || []).map(code => new Code(code.value, code.type));
    this.assets = operator.assets || [];
  }
}

export class Code {
  constructor(value, type) {
    type = (type || '').toUpperCase();
    this.value = value;
    this.type = type;
  }
}

export const CODE_TYPE_ENUM = {
  PIN: 'PIN',
  ZTR_RFID: 'ZTR_RFID',
  IPAF: 'IPAF'
};
